import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    loading: false,
    error: null,
    packages: [],
    users: [],
    total: 0,
    loadingUsers: false,
});

const actions = {
    async userPackageReadAll({commit}, payload) {
        try {
            await commit('userPackageReadAllBegin');
            const response = await DataService.get(`/user-packages?${new URLSearchParams(payload).toString()}`);
            await commit('userPackageReadAllSuccess', response.data.data);
        } catch (err) {
            commit('userPackageReadAllErr', err);
        }
    },

    async userPackageAdd({commit}, payload) {
        try {
            await commit('userPackageAddBegin');
            const response = await DataService.post('/user-packages', payload);
            await commit('userPackageAddSuccess', response.data.data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            commit('userPackageAddErr', err);
        }
    },

    async userPackageUpdate({commit}, payload) {
        try {
            await commit('userPackageUpdateBegin');
            const response = await DataService.put(`/user-packages/${payload.id}`, payload);
            await commit('userPackageUpdateSuccess', response.data.data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            commit('userPackageUpdateErr', err);
        }
    },

    async packageReadAll({commit, query}) {
        try {
            //await commit('packageReadAllBegin');
            const response = await DataService.get(`/packages?${new URLSearchParams(query).toString()}`);
            await commit('packageReadAllSuccess', response.data.data);
        } catch (err) {
            commit('packageReadAllErr', err);
        }
    },

    async packageUserReadAll({commit}, query) {
        try {
            await commit('userReadAllBegin');
            const response = await DataService.get(`/users?${new URLSearchParams(query).toString()}`);
            await commit('userReadAllSuccess', response.data.data);
        } catch (err) {
            commit('userReadAllErr', err);
        }
    }

};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
  };